import asyncActionTypes from './types.js';
import errorTracking from '../../scripts/analytics/creators/manage';
import { getFulfillRefundData } from '../../api-wrapper/api.js';
import { sendAnalytics } from '../../scripts/analytics/tracker.js';

export const getFulfillRefundStart = () => ({
  type: asyncActionTypes.RETRIEVE_FULFILL_REFUND.START,
});

export const getFulfillRefund = (response) => ({
  type: asyncActionTypes.RETRIEVE_FULFILL_REFUND.SUCCESS,
  payload: response,
});

export const getFulfillRefundFail = (error) => ({
  type: asyncActionTypes.RETRIEVE_FULFILL_REFUND.FAIL,
  error: error,
});

export default function getFulfillRefundDataActions(email, name, ticketNumber, documentNumbers, refundForCode96Dot5) {
  return function action(dispatch) {
    dispatch(getFulfillRefundStart());
    const response = getFulfillRefundData(email, name, ticketNumber, dispatch, documentNumbers, refundForCode96Dot5);
    response.then(response => {
      if (response?.status >= 400 || response?.fulfillError) {
        // eslint-disable-next-line no-console
        console.error(response);
        dispatch(getFulfillRefundFail());
        dispatch(
          sendAnalytics({
            eventCreator: errorTracking.errorTrackingRefund({
              event: 'error',
              type: 'FATAL',
              statusCode: response?.status,
              errorData: {
                code: '13116203',
                actionable: 'ABORT',
                msg: response?.Message || response?.message,
                extraInfo: {
                  // eslint-disable-next-line camelcase
                  debugging_stuff_here: response?.Message || response?.message,
                },
              },
              actionType: 'RETRIEVE_FULFILL_REFUND',
            }),
          })
        );
      } else {
        dispatch(getFulfillRefund(response));
      }
    }).catch((error) => {
      // eslint-disable-next-line no-console
      console.error(error);
      dispatch(getFulfillRefundFail());
    });
  };
}